import { GET_APPOINTMENT_BY_ID } from './constants';
import { TelePlatformMeta } from './fetch-vc-meta';

import fetchWithRefresh from './fetchWithRefresh';

export interface AppoitmentResponse {
    success: boolean;
    error?: string;
    status?: number;
    data?: Appointment;
}

export interface Appointment {
    full_date: string;
    date: string;
    doctor_oid: string;
    aid: string;
    patient_uuid: string;
    patient_oid?: string | null;
    clinic_id: string;
    channel?: null;
    onsched_id: string;
    status: string;
    start_time: string;
    end_time: string;
    visit_start?: null;
    visit_end?: null;
    created_at: string;
    payment_id?: null;
    payment_status?: null;
    sa_id?: null;
    tele_id?: null;
    amount?: null;
    prescription_id?: string | null;
    prescription_url?: string | null;
    print_prescription_url?: string | null;
    follow_up?: string | null;
    stage: string;
    patient: Patient;
    'visit-type'?: string;
    'type-display'?: string;
    rc?: boolean; // call back requested
    callback_requested?: string;
    cp?: boolean; // can park
    vc_meta: TelePlatformMeta | null;
}
export interface Patient {
    'is-p'?: boolean | null;
    fln: string;
    ln?: string | null;
    mobile?: string;
    at?: string | null;
    'dob-valid'?: boolean | null;
    dob?: string | null;
    fn?: string | null;
    mn?: string | null;
    uuid: string;
    oid?: string | null;
    email?: string | null;
    gen?: string | null;
    'is-d'?: boolean | null;
}

export default (aid: string): Promise<AppoitmentResponse> =>
    fetchWithRefresh(GET_APPOINTMENT_BY_ID(aid), {
        mode: 'cors',
        credentials: 'include',
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('GET_APPOINTMENT_BY_ID failed');
        }
    });
